module.exports = __webpack_public_path__ + "img/message_board_icon_sp.193d1f3e.svg";